import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { hydrate, startPersist } from './canvas/storage/persist.ts';
import './styles/globals.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element missing from index.html');

// Hydrate scene from IndexedDB before subscribing the persistence layer
// so we don't immediately re-save the just-loaded state.
void hydrate().finally(() => {
  startPersist();
});

createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
